<template>
  <section class="style-section">
    <div class="title-guide">模块图标</div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 200px; height: 200px" :src="url1" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">功能</div>
    <div class="content-guide">
      本模块用于建立悬浇箱梁的单梁模型（包含桥梁下部构造），包括连续梁和连续刚构。
      模型包含了悬浇施工的整个挂篮逐段悬浇施工过程。
    </div>
    <div class="content-guide" style="font-weight: 600">
      本模块支持桥梁曲线布置、变宽布置，不支持斜交布置。
    </div>
    <div class="img-guide">
      <el-image
        class="size-img"
        style="width: 700px; height: 240px"
        :src="url2"
        :zoom-rate="1.2"
        :max-scale="1.5"
        :min-scale="0.2"
        :preview-src-list="srcList2"
        :initial-index="0"
        fit="cover"
      />
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">模块设计理念</div>
    <div class="content-guide">
      对于悬浇箱梁来说，建模最麻烦的部分在于钢束输入和施工阶段定义。
      施工阶段定义采用代码方式是很容易的，而钢束输入难点主要在于将图纸参数转换为几何参数。
      由于悬浇箱梁的钢束形状在设计上都是由张拉端线型和0号块孔道定位来组合决定的，
      所以考虑利用将钢束的形状按立面方向与平面方向分解，再按图纸的张拉端线型、0号块孔道定位参数、
      锚固点之间的距离（可以用锚固节段编号换算）来进行平面定位，这样就大大减少了钢束形状换算工程量。
      你不再需要换算钢束水平方向上长度、也不需要换算钢束的横向位置差，仅仅需要告诉程序钢束锚固在哪个节段、0号块截面它的位置在哪里。
      这样就大大减少了参数输入量，降低了建模难度，加快了建模速度。
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">模块使用流程</div>
    <div class="content-guide">
      <div>本模块常规使用流程如下：</div>
      <li>定义孔跨布置——曲线桥梁引入路线文件</li>
      <li>定义桥面布置参数（桥面宽度布置）</li>
      <li>选择汽车荷载，输入人群荷载</li>
      <li>输入桥面铺装厚度</li>
      <li>选择桥梁的结构类型、桥面横坡形成、箱室类型</li>
      <li>填写需要的自动计算参数</li>
      <li>点击“自动计算箱梁参数”按钮，让程序根据已有参数匹配箱梁的所有参数</li>
      <li>根据需要调整箱梁的分段信息、外形尺寸、底板腹板尺寸、0号块尺寸</li>
      <li>根据需要调整箱梁端部、跨中部位尺寸</li>
      <li>
        修改墩身高度、桩基长度，点击“自动匹配参数”按钮，让程序根据已有参数匹配桥墩的所有参数，然后补充地质参数
      </li>
      <li>切换到“腹板钢束”窗口，根据需要调整箱梁腹板预应力钢束尺寸</li>
      <li>切换到“顶板钢束”窗口，根据需要调整箱梁顶板预应力钢束尺寸</li>
      <li>切换到“底板钢束”窗口，根据需要调整箱梁底板预应力钢束尺寸</li>
      <li>切换到“合拢钢束”窗口，根据需要调整箱梁合拢预应力钢束尺寸</li>
      <li>切换到“钢筋尺寸”窗口，根据需要调整钢筋尺寸参数</li>
      <li>
        切换到“其他参数”窗口，根据需要设置温度变化、支座沉降、风荷载、挂篮荷载等参数
      </li>
      <li>切换到“导出设置”窗口，设置汽车荷载放大系数</li>
      <li>
        保存项目文件，然后导出mct文件，mct文件导入到Midas
        Civil后即可得到计算模型
      </li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image
          class="size-img"
          style="width: 700px; height: 420px"
          :src="url3"
          :zoom-rate="1.2"
          :max-scale="1.5"
          :min-scale="0.2"
          :preview-src-list="srcList3"
          :initial-index="0"
          fit="cover"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">桥梁基本参数</div>
    <div class="content-guide">
      <li>跨径组合</li>
      <div>
        根据自己的需要输入跨径组合，可以采用“3-30”、“20+20”、“29.94+30+30+29.94”这样的方式，多跨连接符号仅支持“+”和“-”。
      </div>
      <li>选择曲线时需要导入路线文件，路线文件格式详见相关说明。</li>
      <li>
        起点桩号——引入路线文件后，输入桥梁起点对应路线文件的桩号，程序将以该桩号为桥梁起点、结合路线文件计算桥梁各部位平面位置。
      </li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 260px; height: 123px" :src="url4" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">桥面布置</div>
    <div class="content-guide">
      <li>
        整幅、分幅——两者的区别主要在于模型中车道的计算和布置。选择整幅时，W6和W7如果输入0，
        则W5+W8作为一个行车道整体宽度按照规范中的对向行驶进行车道布置。车道布置考虑了偏载和居中两种工况。
      </li>
      <li>
        W1～W12——对应示意图各部位宽度。程序会将W1～W12的数值相加再考虑加宽值作为箱梁的顶面宽度。
      </li>
      <li>荷载Q1～Q6——该荷载为除桥面铺装以外作用在桥面的其他荷载。</li>
      <div>Q1对应W1、W12宽度范围内的荷载（如人行道护栏、防撞护栏自重），</div>
      <div>Q2对应W2、W11宽度范围内的荷载(如人行道板自重)，</div>
      <div>
        Q3对应W3、W10宽度范围内的荷载（如非机动车道铺装调平层除开等厚部分自重），
      </div>
      <div>Q4对应W4、W9宽度范围内的荷载（如快慢车道分隔带自重），</div>
      <div>
        Q5对应W5、W8宽度范围内的荷载（如主行车道铺装调平层除开等厚部分自重），
      </div>
      <div>
        Q6对应W6、W7宽度范围内的荷载（如中央分隔带自重、分幅时右侧护栏自重）。
      </div>
      <div>特别注意荷载Q1～Q6的单位为kPa，即kN/m2。</div>
      <li>
        路线中心线到梁板边缘距离L1——本参数用于曲线桥时梁板的横向定位，便于计算箱梁中心线位置（程序按考虑加宽后换算出的箱梁中心线进行建模）。
      </li>
      <li>
        箱梁名义高距路线中心线距离——当考虑采用“腹板变高”方式导出模型时，该参数用于计算箱梁顶面各点位置。
      </li>
      <li>桥面加宽参数：</li>
      <div>
        选择对应的公路等级及加宽类别，点击计算，程序会根据输入的路线文件自动进行计算，计算数值显示在文本框内。
      </div>
      <div>你也可以点击“+”按钮增加加宽位置，输入对应桩号的加宽值。</div>
      <div>加宽是按直线进行线性加宽</div>
      <li>桥面超高参数：</li>
      <div>
        当主窗体选择“腹板变高”时，程序生成的截面顶面是允许带横坡的，横坡值即为本表内容。
      </div>
      <div>
        选择设计时速和采用规范项，填写标准横坡（%）数值（设计高程位置比两边高，输入正值；设计高程位置比两边低，输入负值），点击计算，程序会自动计算横坡（设计高程位置比左侧或右侧高，横坡数值为负值，设计高程位置比左侧或右侧低，横坡数值为正值）。
      </div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image
          class="size-img"
          style="width: 700px; height: 237px"
          :src="url5"
          :zoom-rate="1.2"
          :max-scale="1.5"
          :min-scale="0.2"
          :preview-src-list="srcList5"
          :initial-index="0"
          fit="fill"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">材料参数</div>
    <div class="content-guide">
      <li>混凝土标号——选择箱梁混凝土采用的标号</li>
      <li>预应力钢材——选择箱梁采用的预应力钢束型号</li>
      <li>预应力管道——选择箱梁预应力钢束采用的管道类型</li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 204px; height: 123px" :src="url6" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">桥面活荷载</div>
    <div class="content-guide">
      <li>
        汽车荷载——可以选择公路-Ⅰ级和公路-Ⅱ级。城-A级等效公路-Ⅰ级，城-B级等效公路-Ⅱ级。
      </li>
      <li>
        人群荷载——考虑人行道宽度后的人群荷载，该值不考虑横向分布系数，不考虑人群荷载时输入0。
      </li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 171px; height: 123px" :src="url7" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">桥面铺装</div>
    <div class="content-guide">
      <li>
        沥青混凝土层厚度——输入桥面沥青混凝土层的厚度。
        模型中该厚度乘以行车道宽度及密度（按24kN/m3取值）作为桥面荷载施加在梁体上。
        另外该厚度也用于温度梯度计算。桥梁没有该层时请输入数值0。
      </li>
      <li>
        水泥混凝土层厚度——输入结构宽度范围内水泥混凝土层的厚度。
        模型中该厚度乘以桥梁全宽及密度（按26kN/m3取值）作为桥面荷载施加在梁体上。
        如果沥青混凝土厚度为0，则程序按水泥混凝土铺装以该厚度作为温度梯度计算参数。
      </li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 133px; height: 123px" :src="url8" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">箱梁基本参数</div>
    <div class="content-guide">
      <li>
        结构类型——有连续梁和连续刚构种类型，用于自动计算时匹配不同的箱梁参数及边界条件。
      </li>
      <li>横坡形成</li>
      <div>
        腹板等高——选择后程序生成的单元截面采用Midas
        Civil自带截面，且箱梁顶面水平，不考虑横坡。
      </div>
      <div>
        腹板变高——选择后程序生成的单元截面采用自定义数值截面，箱梁顶面按“桥面布置”中输入的桥面横坡进行布置。
      </div>
      <li>箱室类型——有单箱单室、单箱双室和单箱三室3种类型。</li>
      <div style="font-weight: 600">
        注意：由于采用“腹板等高”方式生成的模型是采用Midas
        Civil自带截面，在mct文件导入到Midas Civil中的时候，Midas
        Civil需要重新计算每一个截面的截面特性参数，故导入速度会非常慢！
        没有特殊要求的话，建议将桥面横坡设置为0，然后用“腹板变高”方式导出mct文件。
      </div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 172px; height: 123px" :src="url9" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">自动计算参数</div>
    <div class="content-guide">
      <li>
        指定合拢段长——勾选并输入数值后锁定模型中的合拢段长度，不指定时程序默认是2m
      </li>
      <li>
        指定节段数量——勾选并输入数值后锁定模型中的最大悬臂时的节段个数，自动计算时程序会按指定的节段数自动匹配节段长度，
        但是如果无法生成合适的节段长度时（程序默认按0.5m的数量级匹配），会主动调整该节段数量
      </li>
      <li>指定翼缘宽度——输入数值后锁定模型中的箱梁翼缘宽度</li>
      <li>
        自动计算箱梁参数——程序会按照填写的跨径组合、桥面布置情况（宽度）自动计算并匹配纵向分段、截面尺寸、预应力钢束布置等整个模型的所有参数，
        设计人员再按自己的设计习惯、要求、受力需要去调整各个部分的参数
      </li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 354px; height: 123px" :src="url10" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">立面布置——悬浇分段</div>
    <div class="content-guide">
      <li>本部分填写箱梁的悬浇节段分段参数。</li>
      <li>各参数意义如下：</li>
      <div>
        左、右悬臂段n@L——用“,”分隔每一个节段长度，多一个相同的节段可以缩写为“n@L”的形式（n为段数，L为单个节段长）。
        注意节段顺序是按由左向右顺序排列，即左悬臂段是以n号节段长度开始输入，右悬臂段是以1号节段长度开始输入。
      </div>
      <div>0号块L——每一个桥墩处0号块的长度</div>
      <div>梁高H——每一个桥墩处0号块的高度</div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 408px; height: 101px" :src="url11" :fit="fit" />
        <el-image
          style="width: 670px; height: 320px"
          :src="url11a"
          :fit="fit"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">立面布置——现浇合拢段、梁端分段</div>
    <div class="content-guide">
      <li>本部分填写箱梁立面图中现浇合拢段、桥梁两端现浇段长度。</li>
      <li>各参数意义如下：</li>
      <div>现浇合拢段长度L——箱梁每一个现浇合拢段的长度</div>
      <div>现浇合拢段高度H——箱梁每一个现浇合拢段的高度</div>
      <div>梁端分段现浇段L——桥梁起点、终点现浇段的长度</div>
      <div>抛物线次数——箱梁高度及底板厚度的变化方式。</div>
      <li>
        数据核查——输入完前面的参数，需要点击本按钮核查各梁段长度之和与跨径组合填写的每一跨跨径是否相符，如果不一致会弹框提示。
      </li>
      <li>各跨统一——点击后将会将第1跨的参数复制给其他所有跨。</li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 328x; height: 208px" :src="url12" :fit="fit" />
      </div>
      <el-scrollbar height="300">
        <div class="title-img">
          <el-image
            style="width: 670px; height: 320px"
            :src="url12a"
            :fit="fit"
          />
          <el-image
            style="width: 670px; height: 320px"
            :src="url12b"
            :fit="fit"
          />
        </div>
      </el-scrollbar>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">立面布置——底板厚</div>
    <div class="content-guide">
      <li>
        本部分填写箱梁各个墩台位置的底板厚度，以桥墩为基准分左侧右侧填写。
      </li>
      <li>各参数意义如下：</li>
      <div>左端部H——左侧最大悬臂节段端部的底板厚度</div>
      <div>左根部H——左侧箱梁变高段最高部位转点处的底板厚度</div>
      <div>0号块H——0号块处的底板厚度</div>
      <div>右根部H——右侧箱梁变高段最高部位转点处的底板厚度</div>
      <div>右端部H——右侧最大悬臂节段端部的底板厚度</div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 365px; height: 100px" :src="url13" :fit="fit" />
        <el-image
          style="width: 665px; height: 320px"
          :src="url13a"
          :fit="fit"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">立面布置——腹板厚度</div>
    <div class="content-guide">
      <li>
        本部分填写箱梁每一侧悬浇部分的腹板厚度变化值，最多支持腹板厚度变化2次，有3种腹板厚度。
        考虑到设计习惯悬浇施工左右侧腹板厚度变化节段部位均对称布置，故仅填写单侧数值。
      </li>
      <li>各参数意义如下：</li>
      <div>0号块B——0号块位置的腹板厚度B，通常与1号段腹板厚度B1保持一致。</div>
      <div>厚度B1——1号段腹板厚度</div>
      <div>
        节段n1——腹板变化后第2种厚度的起始节段编号。注意渐变段程序默认为前面1个节段。如果没有可以填写0。
      </div>
      <div>厚度B2——腹板的第2种厚度。如果没有可以填写0。</div>
      <div>节段n2——腹板变化后第3种厚度的起始节段编号。如果没有可以填写0。</div>
      <div>厚度B3——腹板的第3种厚度。如果没有可以填写0。</div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 380px; height: 100px" :src="url14" :fit="fit" />
        <el-image
          style="width: 655px; height: 320px"
          :src="url14a"
          :fit="fit"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">立面布置——0号块</div>
    <div class="content-guide">
      <li>本部分填写箱梁立面图中纵向尺寸，包括端横梁和中横梁。</li>
      <li>各参数意义如下：</li>
      <div>底长L1——对应桥墩0号块底面等高段长度</div>
      <div>外挑L2——对应桥墩0号块隔板外侧至0号块外侧距离</div>
      <div>
        隔板数——对应桥墩0号块隔板总数，仅支持1、2、4三个数值，其中1对应连续梁，2和4对应连续刚构
      </div>
      <div>隔板厚L3——对应桥墩0号块单个隔板的厚度</div>
      <div>隔板距L4——对应桥墩0号块2个隔板之间的距离</div>
      <div>顶板厚H1——对应桥墩0号块顶板的厚度</div>
      <div>倒角L5——对应桥墩0号块底板倒角的长度</div>
      <div>倒角H2——对应桥墩0号块底板倒角的高度</div>
      <div>倒角L6——对应桥墩0号块顶板倒角的长度</div>
      <div>倒角H3——对应桥墩0号块底板倒角的高度</div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 746px; height: 98px" :src="url15" :fit="fit" />
        <el-image
          style="width: 655px; height: 320px"
          :src="url15a"
          :fit="fit"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">结构尺寸——起点端、终点端</div>
    <div class="content-guide">
      <li>本部分填写箱梁立面图中纵向尺寸，包括端横梁和中横梁。</li>
      <li>各参数意义如下：</li>
      <div>L1——起终点梁端至支座中心线处距离</div>
      <div>L2——起终点支座中心线至端横梁靠跨中边缘的距离</div>
      <div>L3——起终点端部底板倒角长度</div>
      <div>L4——起终点端部顶板倒角长度</div>
      <div>H1——起终点端部底板倒角高度</div>
      <div>H2——起终点端部顶板倒角高度</div>
      <div>L5——起终点端部腹板加厚段长度</div>
      <div>L6——起终点端部腹板倒角长度</div>
      <div>G1——起终点端部腹板加厚值</div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 372px; height: 165px" :src="url16" :fit="fit" />
        <el-image
          style="width: 372px; height: 165px"
          :src="url16a"
          :fit="fit"
        />
      </div>
      <el-scrollbar height="300">
        <div class="title-img">
          <el-image
            style="width: 665px; height: 320px"
            :src="url16b"
            :fit="fit"
          />
          <el-image
            style="width: 665x; height: 320px"
            :src="url16c"
            :fit="fit"
          />
        </div>
      </el-scrollbar>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">结构尺寸——标准横断面</div>
    <div class="content-guide">
      <li>本部分填写箱梁标准横断面的部分尺寸参数。</li>
      <li>各参数意义如下：</li>
      <div>H1——箱室上缘倒角处顶板厚度</div>
      <div>H2——箱室中心线处顶板厚度</div>
      <div>B1——箱梁悬臂翼缘总宽</div>
      <div>
        B2——外侧翼缘存在二次倒角时，转点到翼缘根部的水平距离。如果没有二次倒角，请填0.001。
      </div>
      <div>H3——悬臂翼缘端部高度</div>
      <div>H4——悬臂翼缘根部对应高度</div>
      <div>
        H5——外侧翼缘存在二次倒角时，转点到翼缘根部的垂直距离。如果没有二次倒角，请填0.001。
      </div>
      <div>D1～D8——箱梁顶板、底板倒角尺寸</div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 616px; height: 161px" :src="url17" :fit="fit" />
      </div>
      <el-scrollbar height="300">
        <div class="title-img">
          <el-image
            style="width: 665px; height: 320px"
            :src="url17a"
            :fit="fit"
          />
          <el-image
            style="width: 665px; height: 320px"
            :src="url17b"
            :fit="fit"
          />
          <el-image
            style="width: 665x; height: 320px"
            :src="url17c"
            :fit="fit"
          />
          <el-image
            style="width: 665px; height: 320px"
            :src="url17d"
            :fit="fit"
          />
        </div>
      </el-scrollbar>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">结构尺寸——横隔板</div>
    <div class="content-guide">
      <li>本部分填写箱梁横隔板尺寸，该横隔板在模型中仅以集中力的形式存在。</li>
      <li>各参数意义如下：</li>
      <div>GB1——跨中横隔板的厚度。</div>
      <div>GB2、GB3——跨中横隔板的倒角宽度、高度。</div>
      <div>
        横隔板位置——跨中横隔板中心距本跨起点线的路线桩号的绝对距离，
        多道横隔板时用“,”号分隔，但数值均为距本跨起点线的路线桩号的绝对距离，不是相互间距离。
        若不考虑跨中横隔板，则该位置信息需要删除，切记不能填写0。
      </div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 415px; height: 119px" :src="url18" :fit="fit" />
        <el-image
          style="width: 665px; height: 320px"
          :src="url18a"
          :fit="fit"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">桥墩尺寸——桥墩基本信息</div>
    <div class="content-guide">
      <li>本部分填写桥墩的类型、高度、长度基本参数。</li>
      <li>各参数意义如下：</li>
      <div>
        桥墩类型——单击后会在“刚构”和“支座”两者间切换，“刚构”代表上部构造与桥墩采用刚接的方式，“支座”代表该桥墩采用连续梁支座的方式进行上部构造与桥墩连接
      </div>
      <div>墩身高度——对应桥墩的墩身部分高度</div>
      <div>桩基长度——对应桥墩的桩基部分长度</div>
      <li>
        自动匹配参数——点击本按钮后，程序会根据桥梁跨径、结构类型、墩身高度等参数自动匹配相应的墩身参数
      </li>
      <li>
        复制桥墩参数——调整好单个桥墩参数后，点击本按钮允许将该桥墩所有参数复制给其他桥墩
      </li>
      <li>混凝土标号——选择墩身、承台、桩基各个部分的混凝土标号</li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 725px; height: 152px" :src="url19" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">桥墩尺寸——墩身基本尺寸</div>
    <div class="content-guide">
      <li>本部分填写桥墩墩身、承台、桩基的截面尺寸参数。</li>
      <li>墩身截面参数意义如下：</li>
      <div>
        墩身截面——目前仅支持双肢实心、单肢实心、双肢空心、单肢空心4种断面型式。注意墩身截面类型选择应与上部构造箱梁匹配。
        例如上部构造0号块采用单横隔板，那么下部构造就不应该采用双肢截面。
      </div>
      <div>宽度B1——其中一肢截面的总宽</div>
      <div>高度H1——其中一肢截面的总厚</div>
      <div>宽度B2——其中一肢截面箱内室空心部分的宽度</div>
      <div>高度H2——其中一肢截面箱内室空心部分的高度</div>
      <div>倒角T1——其中一肢截面箱内室空心部分的倒角尺寸</div>
      <li>实心段参数意义如下：</li>
      <div>
        当截面类型选择空心截面时，要求填写墩身顶面及底面实心段的长度参数
      </div>
      <li>系梁参数意义如下：</li>
      <div>根数——当前桥墩系梁总数</div>
      <div>间距1——从下向上数第一道系梁距承台的距离</div>
      <div>间距2——系梁与系梁间的中心距离</div>
      <div>截面宽B——系梁截面的宽度</div>
      <div>截面高H——系梁截面的高度</div>
      <li>承台参数意义如下：</li>
      <div>平面宽B1——承台横桥向长度</div>
      <div>平面长L1——承台顺桥向长度</div>
      <div>承台厚H1——承台厚度</div>
      <li>桩基参数意义如下：</li>
      <div>桩基平面布置形式有网格型和梅花形2种布置形式</div>
      <div>
        横桥向排数——桩基横桥向的排数（梅花形布置时输入数量不包含中间内插的桩基）
      </div>
      <div>
        顺桥向排数——桩基顺桥向的排数（梅花形布置时输入数量不包含中间内插的桩基）
      </div>
      <div>
        横桥向间距——桩基横桥向的桩基中心距离（梅花形布置时输入数量不包含中间内插的桩基）
      </div>
      <div>
        顺桥向间距——桩基顺桥向的桩基中心距离（梅花形布置时输入数量不包含中间内插的桩基）
      </div>
      <div>直径——桩基的直径</div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 728px; height: 196px" :src="url20" :fit="fit" />
      </div>
      <el-scrollbar height="300">
        <div class="title-img">
          <el-image
            style="width: 665px; height: 320px"
            :src="url20a"
            :fit="fit"
          />
          <el-image
            style="width: 665x; height: 320px"
            :src="url20b"
            :fit="fit"
          />
          <el-image
            style="width: 665x; height: 320px"
            :src="url20c"
            :fit="fit"
          />
        </div>
      </el-scrollbar>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">桥墩尺寸——地质参数</div>
    <div class="content-guide">
      <li>地质参数意义如下：</li>
      <div>地层数量可以通过右侧“+”、“-”按钮进行增减</div>
      <div>类型——有土体、岩体两种类型选择，通过点击单元格切换</div>
      <div>m值（C值）——土体类型填写对应的m值，岩体类型填写对应的C值</div>
      <div>厚度——相同参数地层的厚度</div>
      <li>注意：地层厚度之和应超过桩基长度，未含桩基的地层应删除。</li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 246px; height: 257px" :src="url21" :fit="fit" />
        <el-image
          style="width: 665px; height: 320px"
          :src="url21a"
          :fit="fit"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">桥墩尺寸——支座参数</div>
    <div class="content-guide">
      <li>支座各部位参数意义如下：</li>
      <div>支座个数——单个墩台位置横桥向支座个数</div>
      <div>
        支座间距——每一个支座之间的间距，程序会按桥梁中心线左右对称布置。
      </div>
      <div>支座总高——支座系统全高</div>
      <div>
        支座约束——每一个支座的约束类型（有4种，详见下方示意图），可以填写1～4。
        约束类型涉及到导出模型的边界条件是否正确，如果无把握正确填写，则建议尽量使用默认的约束类型。
      </div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 367px; height: 146px" :src="url22" :fit="fit" />
        <el-image
          style="width: 665px; height: 320px"
          :src="url22a"
          :fit="fit"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">腹板钢束——立面布置</div>
    <div class="content-guide">
      <li>
        复制钢束参数——点击输入桥墩编号，可以把本桥墩腹板钢束参数全部复制给其他桥墩，当需复制给多个桥墩时采用“，”号分隔。
      </li>
      <li>
        参数从边腹板中复制——点击本按钮后可以将本桥墩边腹板钢束参数全部复制到中腹板。
      </li>
      <li>基本参数意义如下：</li>
      <div>W束孔数——当前桥墩悬浇段考虑布置的腹板束总孔道数量</div>
      <div>单孔根数——当前桥墩腹板束单个孔道内的钢绞线根数</div>
      <div>布置列数——单个腹板上腹板束布置的列数（最多支持3列）</div>
      <div>布置行数——单个腹板上腹板束布置的行数</div>
      <div>
        横向间距——以左侧腹板为基准，DV1为腹板外侧到第一列腹板束中心的间距，DV2为腹板束相互之间的横向中心距
      </div>
      <div>
        竖向间距——以左侧腹板为基准，DH1为顶面第一行腹板束中心至对应箱梁顶面的间距，DH2为腹板束相互之间的竖向中心距
      </div>
      <div>锚固点距D——锚固点至锚固节段端部的水平距离</div>
      <div>
        钢束布置调整——当W束孔数、布置列数、布置行数任意一项数值改变后，点击本按钮将根据修改值自动计算钢束布置，
        同时计算对应的横断面布置、立面布置；当W束孔数、布置列数、布置行数均不变，仅改动钢束布置表格中的各钢束位置，
        点击本按钮将按调整后的钢束布置位置计算对应的横断面布置、立面布置
      </div>
      <li>钢束布置：</li>
      <div>
        每一根钢束布置的位置，可以手工调整，数值为本钢束锚固节段号。程序将按照钢束位置自动换算钢束中间段的横向、竖向位置
      </div>
      <div>注意钢束布置的个数应与W束孔数保持一致</div>
      <li>0号块截面钢束横断面参数：</li>
      <div>束号——腹板束对应编号</div>
      <div>单孔根数——本腹板束采用的钢绞线根数</div>
      <div>水平距离L——本腹板束中心距腹板外侧边缘距离</div>
      <div>垂直高度H——本腹板束中心距箱梁顶面的距离</div>
      <div>锚固节段编号——本腹板束对应的锚固节段编号</div>
      <div style="font-weight: 600">
        注意：本表除单孔根数、锚固节段编号数值会进入最终导出模型中，
        其余参数仅仅用于计算下方锚固点参数表格，钢束实际线型参数以下方表格为准。
      </div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 747px; height: 337px" :src="url23" :fit="fit" />
        <el-scrollbar height="300">
          <div class="title-img">
            <el-image
              style="width: 665px; height: 320px"
              :src="url23a"
              :fit="fit"
            />
            <el-image
              style="width: 665x; height: 320px"
              :src="url23c"
              :fit="fit"
            />
            <el-image
              style="width: 665x; height: 320px"
              :src="url23b"
              :fit="fit"
            />
            <el-image
              style="width: 665x; height: 320px"
              :src="url23d"
              :fit="fit"
            />
          </div>
        </el-scrollbar>
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">腹板钢束——锚固点参数</div>
    <div class="content-guide">
      <li>基本参数意义如下：</li>
      <div>
        锚固点位置——通过选择“锁定竖向占比”或者“锁定底面距离”两种方式迅速计算腹板束在锚固点的竖向高度位置
      </div>
      <div>
        弯起点位置——通过选择“锁定弯起角度”或者“锁定水平长度”两种方式迅速计算腹板束下弯段的水平长度及对应的弯起角度
      </div>
      <div>R——希望统一的腹板束竖弯半径</div>
      <div>
        调整——点击本按钮将按照选择进行计算。每一根腹板束的参数细致调整请在表格中双击对应单元格后修改
      </div>
      <li>左端、右端立面参数意义如下：</li>
      <div>束号——腹板束对应编号，不可以修改</div>
      <div>高度H——锚固点至箱梁底面的竖向距离</div>
      <div>长度L——下弯段的水平长度</div>
      <div>角度A——下弯段与水平线的夹角。本角度与长度L存在换算关系</div>
      <div>半径R——腹板束竖弯对应的半径</div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 747px; height: 301px" :src="url24" :fit="fit" />
        <el-image
          style="width: 665px; height: 320px"
          :src="url24a"
          :fit="fit"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">顶板钢束——断面布置</div>
    <div class="content-guide">
      <li>
        复制钢束参数——点击输入桥墩编号，可以把本桥墩顶板钢束参数全部复制给其他桥墩，当需复制给多个桥墩时采用“，”号分隔。
      </li>
      <li>
        参数从边腹板中复制——点击本按钮后可以将本桥墩边腹板钢束参数全部复制到中腹板。
      </li>
      <li>基本参数意义如下：</li>
      <div>T束孔数——当前桥墩悬浇段考虑布置的顶板束总孔道数量</div>
      <div>单孔根数——当前桥墩顶板束单个孔道内的钢绞线根数</div>
      <div>布置列数——顶板上单侧顶板束布置的列数</div>
      <div>布置行数——顶板上单侧顶板束布置的行数（最多支持3行）</div>
      <div>锚固点定位L1——最外侧腹板束与顶板束锚固点的横向中心距离</div>
      <div>锚固点定位H1——顶板束锚固点至箱梁顶面的距离</div>
      <div>
        横向间距——L2为锚固点到第2列顶板束中心的间距，L3为顶板束相互之间的横向中心距
      </div>
      <div>
        竖向间距——H2为顶面第一行顶板束中心至对应箱梁顶面的间距，H3为顶板束相互之间的竖向中心距
      </div>
      <li>钢束布置：</li>
      <div>
        每一根钢束布置的位置，可以手工调整，数值为本钢束锚固节段号。程序将按照钢束位置自动换算钢束中间段的横向、竖向位置
      </div>
      <div>注意钢束布置的个数应与T束孔数保持一致</div>
      <li>
        调整——当T束孔数、布置列数、布置行数任意一项数值改变后，点击本按钮将根据修改值自动计算钢束布置，
        同时计算对应的平面布置、立面布置；当T束孔数、布置列数、布置行数均不变，仅改动钢束布置表格中的各钢束位置，
        点击本按钮将按调整后的钢束布置位置计算对应的平面布置、立面布置
      </li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 734px; height: 257px" :src="url25" :fit="fit" />
        <el-image
          style="width: 665px; height: 320px"
          :src="url25a"
          :fit="fit"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">顶板钢束——平面布置</div>
    <div class="content-guide">
      <li>基本参数意义如下：</li>
      <div>编号——顶板钢束编号，不可以修改</div>
      <div>锚固节段——本钢束锚固的节段编号</div>
      <div>根数——本钢束采用的钢绞线根数</div>
      <div>
        横向D1——本钢束锚固点至腹板外边缘的距离（翼缘侧为正值、箱室侧为负值）
      </div>
      <div>
        横向D2——本钢束中间段至腹板外边缘的距离（翼缘侧为正值、箱室侧为负值）
      </div>
      <div>左端L1——第1平直段的长度</div>
      <div>左端L2——第2平直段的长度，没有平弯时本长度可以填写0.1，不能填0</div>
      <div>左端R1——第1转点半径</div>
      <div>左端R2——第2转点半径</div>
      <div>右端L3——第3平直段的长度，没有平弯时本长度可以填写0.1，不能填0</div>
      <div>右端L4——第4平直段的长度</div>
      <div>右端R3——第3转点半径</div>
      <div>右端R4——第4转点半径</div>
      <li>其他参数意义如下：</li>
      <div>左右对称——勾选后本钢束右半部分孔道形状参数将与左半部分对称</div>
      <div>统一L1——点击“调整”后平面布置中L1数值将均采用本单元格数值</div>
      <div>统一R——点击“调整”后平面布置中R1、R2数值将均采用本单元格数值</div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 738px; height: 186px" :src="url26" :fit="fit" />
        <el-scrollbar height="300">
          <div class="title-img">
            <el-image
              style="width: 665px; height: 320px"
              :src="url26a"
              :fit="fit"
            />
            <el-image
              style="width: 665x; height: 320px"
              :src="url26b"
              :fit="fit"
            />
          </div>
        </el-scrollbar>
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">顶板钢束——立面布置</div>
    <div class="content-guide">
      <li>基本参数意义如下：</li>
      <div>编号——顶板钢束编号，不可以修改</div>
      <div>竖向H1——锚固点至箱梁顶面距离</div>
      <div>竖向H2——中间平直段至箱梁顶面距离</div>
      <div>左端L1——第1平直段的长度</div>
      <div>左端L2——第2平直段的长度，没有竖弯时本长度可以填写0.1，不能填0</div>
      <div>左端R1——第1转点半径</div>
      <div>左端R2——第2转点半径</div>
      <div>右端L3——第3平直段的长度，没有竖弯时本长度可以填写0.1，不能填0</div>
      <div>右端L4——第4平直段的长度</div>
      <div>右端R3——第3转点半径</div>
      <div>右端R4——第4转点半径</div>
      <li>其他参数意义如下：</li>
      <div>左右对称——勾选后本钢束右半部分孔道形状参数将与左半部分对称</div>
      <div>统一L1——点击“调整”后立面布置中L1数值将均采用本单元格数值</div>
      <div>统一R——点击“调整”后立面布置中R1、R2数值将均采用本单元格数值</div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 738px; height: 183px" :src="url27" :fit="fit" />
        <el-image
          style="width: 665px; height: 320px"
          :src="url27a"
          :fit="fit"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">底板钢束——断面布置</div>
    <div class="content-guide">
      <li>
        复制钢束参数——点击输入桥跨编号，可以把本桥跨底板钢束参数全部复制给其他桥跨，当需复制给多个桥跨时采用“，”号分隔。
      </li>
      <li>
        参数从边腹板中复制——点击本按钮后可以将本桥跨边腹板钢束参数全部复制到中腹板。
      </li>
      <li>基本参数意义如下：</li>
      <div>B束孔数——当前桥跨悬浇段考虑布置的底板束总孔道数量</div>
      <div>单孔根数——当前桥墩顶板束单个孔道内的钢绞线根数</div>
      <div>单孔根数——当前桥跨底板束单个孔道内的钢绞线根数</div>
      <div>布置列数——底板上单侧底板束布置的列数</div>
      <div>
        左、右锚固点间距——L1为锚固点中心距腹板内侧距离，L2为当同一断面存在2组底板束锚固点时相互之间间距
      </div>
      <div>
        中间间距——L3为最外侧底板束中心至腹板外边缘距离，L4为底板束相互之间中心距离
      </div>
      <div>
        梁端锚固点间距——H3为第一行锚固点至箱梁底的竖向距离，H4为两行锚固点之间的竖向距离
      </div>
      <div>底板段H1——底板束中间段至箱梁底面距离</div>
      <div>锚固点H2——底板束锚固点至底板底面的竖向距离</div>
      <li>钢束布置：</li>
      <div>
        每一根钢束布置的位置，可以手工调整，数值为本钢束锚固节段号。程序将按照钢束位置自动换算钢束中间段的横向、竖向位置
      </div>
      <div>注意钢束布置的个数应与B束孔数保持一致</div>
      <li>
        调整——当B束孔数、布置列数改变后，点击本按钮将根据修改值自动计算钢束布置，
        同时计算对应的平面布置、立面布置；当B束孔数、布置列数均不变，仅改动钢束布置表格中的各钢束位置，
        点击本按钮将按调整后的钢束布置位置计算对应的平面布置、立面布置
      </li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 742px; height: 226px" :src="url28" :fit="fit" />
        <el-scrollbar height="300">
          <div class="title-img">
            <el-image
              style="width: 665px; height: 320px"
              :src="url28a"
              :fit="fit"
            />
            <el-image
              style="width: 665x; height: 320px"
              :src="url28b"
              :fit="fit"
            />
            <el-image
              style="width: 665x; height: 320px"
              :src="url28c"
              :fit="fit"
            />
          </div>
        </el-scrollbar>
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">底板钢束——平面布置</div>
    <div class="content-guide">
      <li>基本参数意义如下：</li>
      <div>编号——底板钢束编号，不可以修改</div>
      <div>根数——本钢束采用的钢绞线根数</div>
      <div>
        横向D1——本钢束左侧锚固点至腹板外边缘的距离（翼缘侧为正值、箱室侧为负值）
      </div>
      <div>
        横向D2——本钢束中间段至腹板外边缘的距离（翼缘侧为正值、箱室侧为负值）
      </div>
      <div>
        横向D3——本钢束右侧锚固点至腹板外边缘的距离（翼缘侧为正值、箱室侧为负值）
      </div>
      <div>左端L1——第1平直段的长度</div>
      <div>左端L2——第2平直段的长度，没有平弯时本长度可以填写0.1，不能填0</div>
      <div>左端R1——第1转点半径</div>
      <div>左端R2——第2转点半径</div>
      <div>右端L3——第3平直段的长度，没有平弯时本长度可以填写0.1，不能填0</div>
      <div>右端L4——第4平直段的长度</div>
      <div>右端R3——第3转点半径</div>
      <div>右端R4——第4转点半径</div>
      <li>其他参数意义如下：</li>
      <div>左右对称——勾选后本钢束右半部分孔道形状参数将与左半部分对称</div>
      <div>统一L1——点击“调整”后平面布置中L1数值将均采用本单元格数值</div>
      <div>统一R——点击“调整”后平面布置中R1、R2数值将均采用本单元格数值</div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 740px; height: 187px" :src="url29" :fit="fit" />
        <el-image
          style="width: 665px; height: 320px"
          :src="url29a"
          :fit="fit"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">底板钢束——立面布置</div>
    <div class="content-guide">
      <li>基本参数意义如下：</li>
      <div>编号——底板钢束编号，不可以修改</div>
      <div>根数——本钢束采用的钢绞线根数</div>
      <div>左锚固——本钢束左侧锚固的节段编号（起点端输入0）</div>
      <div>右锚固——本钢束右侧锚固的节段编号（终点端输入0）</div>
      <div>竖向H1——左锚固点至箱梁底面距离</div>
      <div>竖向H2——中间段至箱梁底面距离</div>
      <div>竖向H3——右锚固点至箱梁底面距离</div>
      <div>左端L1——第1平直段的长度</div>
      <div>左端L2——第2平直段的长度，没有竖弯时本长度可以填写0.1，不能填0</div>
      <div>左端R1——第1转点半径</div>
      <div>右端L3——第3平直段的长度，没有竖弯时本长度可以填写0.1，不能填0</div>
      <div>右端L4——第4平直段的长度</div>
      <div>右端R2——第2转点半径</div>
      <li>其他参数意义如下：</li>
      <div>左右对称——勾选后本钢束右半部分孔道形状参数将与左半部分对称</div>
      <div>统一L1——点击“调整”后立面布置中L1数值将均采用本单元格数值</div>
      <div>角度控制——采用固定角度方式计算L2长度</div>
      <div>长度控制——采用填入的数值统一L2长度</div>
      <div>统一R——点击“调整”后立面布置中R1、R2数值将均采用本单元格数值</div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 740px; height: 189px" :src="url30" :fit="fit" />
        <el-scrollbar height="300">
          <div class="title-img">
            <el-image
              style="width: 665px; height: 320px"
              :src="url30a"
              :fit="fit"
            />
            <el-image
              style="width: 665x; height: 320px"
              :src="url30b"
              :fit="fit"
            />
          </div>
        </el-scrollbar>
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">合拢钢束——平面布置</div>
    <div class="content-guide">
      <li>
        复制钢束参数——点击输入桥跨编号，可以把本桥跨合拢钢束参数全部复制给其他桥跨，当需复制给多个桥跨时采用“，”号分隔。
      </li>
      <li>基本参数意义如下：</li>
      <div>编号——合拢钢束编号，不可以修改</div>
      <div>根数——本钢束采用的钢绞线根数</div>
      <div>D1——本钢束左侧锚固点至腹板外边缘的距离</div>
      <div>D2——本钢束中间段至腹板外边缘的距离</div>
      <div>D3——本钢束右侧锚固点至腹板外边缘的距离</div>
      <div>左端L1——第1平直段的长度</div>
      <div>左端L2——第2平直段的长度，没有平弯时本长度可以填写0.1，不能填0</div>
      <div>左端R1——第1转点半径</div>
      <div>左端R2——第2转点半径</div>
      <div>右端L3——第3平直段的长度，没有平弯时本长度可以填写0.1，不能填0</div>
      <div>右端L4——第4平直段的长度</div>
      <div>右端R3——第3转点半径</div>
      <div>右端R4——第4转点半径</div>
      <li>其他参数意义如下：</li>
      <div>左右对称——勾选后本钢束右半部分孔道形状参数将与左半部分对称</div>
      <div>统一L1——点击“调整”后平面布置中L1数值将均采用本单元格数值</div>
      <div>统一R——点击“调整”后平面布置中R1、R2数值将均采用本单元格数值</div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 740px; height: 275px" :src="url31" :fit="fit" />
        <el-image
          style="width: 665px; height: 320px"
          :src="url31a"
          :fit="fit"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">合拢钢束——立面布置</div>
    <div class="content-guide">
      <li>基本参数意义如下：</li>
      <div>编号——合拢钢束编号，不可以修改</div>
      <div>根数——本钢束采用的钢绞线根数</div>
      <div>左锚固——本钢束左侧锚固的节段编号（起点端输入0）</div>
      <div>右锚固——本钢束右侧锚固的节段编号（终点端输入0）</div>
      <div>竖向H1——左锚固点至箱梁顶面距离</div>
      <div>竖向H2——中间段至箱梁顶面距离</div>
      <div>竖向H3——右锚固点至箱梁顶面距离</div>
      <div>左端L1——左锚固点至锚固节段端部距离</div>
      <div>左端L2——第1平直段的长度，没有竖弯时本长度可以填写0.1，不能填0</div>
      <div>左端R1——第1转点半径</div>
      <div>右端L3——第2平直段的长度，没有竖弯时本长度可以填写0.1，不能填0</div>
      <div>右端L4——右锚固点至锚固节段端部距离</div>
      <div>右端R2——第2转点半径</div>
      <li>其他参数意义如下：</li>
      <div>左右对称——勾选后本钢束右半部分孔道形状参数将与左半部分对称</div>
      <div>统一L1——点击“调整”后立面布置中L1数值将均采用本单元格数值</div>
      <div>角度控制——采用固定角度方式计算L2长度</div>
      <div>长度控制——采用填入的数值统一L2长度</div>
      <div>统一R——点击“调整”后立面布置中R1数值将均采用本单元格数值</div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 740px; height: 203px" :src="url32" :fit="fit" />
        <el-image
          style="width: 665px; height: 320px"
          :src="url32a"
          :fit="fit"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">钢筋尺寸</div>
    <div class="content-guide">
      <li>
        普通钢筋参数分主梁纵向抗弯钢筋和腹板抗剪箍筋2类。
        程序会根据跨中截面标准段和每一跨端部腹板变宽段作为正弯矩区和负弯矩区的划分。
      </li>
      <li>主梁抗弯钢筋</li>
      <div>
        纵向钢筋在高度方向上将钢筋分为4层，纵向上分为支座加强区与跨中常规区2类。
        参数包括各层钢筋的直径、间距、保护层厚度。
      </div>
      <li>主梁腹板抗剪钢筋</li>
      <div>
        横向箍筋则仅在纵向上分为支座加强区与跨中常规区2类。
        参数包括箍筋直径、肢数、桥长方向间距。
        注意箍筋肢数指的是单个腹板竖向钢筋根数，即一个箍筋算2肢。
      </div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 600px; height: 260px" :src="url33" :fit="fit" />
        <el-image
          style="width: 665px; height: 320px"
          :src="url33a"
          :fit="fit"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">其他参数——整体温变荷载</div>
    <div class="content-guide">
      <div>
        根据桥位处气象情况分别输入整体温升、温降度数，注意实际使用应采用日平均温度的差值，或者采用规范建议值。
      </div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 253px; height: 57px" :src="url34" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">其他参数——汽车制动力参数</div>
    <div class="content-guide">
      <div>
        自行根据车道数输入需要计算汽车制动力的车道数，
        程序会按照每一联全长自动换算制动力大小。
      </div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 146px; height: 57px" :src="url35" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">其他参数——支座沉降</div>
    <div class="content-guide">
      <div>输入墩台需要考虑的最大沉降值。</div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 143px; height: 57px" :src="url36" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">其他参数——温度梯度荷载</div>
    <div class="content-guide">
      <li>
        当采用“腹板变高”方式考虑箱梁顶面横坡生成单梁模型时，
        由于单元截面顶面存在横坡不水平，而程序默认的温度梯度生成是按水平方式做的，
        会导致温度梯度计算失真。故程序制作了使用Midas Civil
        2019V2.2版以后推出的以截面形状为准的温度梯度方式。 使用方法如下：
      </li>
      <div>1.点击程序本按钮，生成温度梯度mct文件。</div>
      <div>
        2.正常导出模型并导入到Midas
        Civil中，找到精力荷载工况“温度梯度（升）”和“温度梯度（降）”，
        将里面的温度梯度荷载删除。
      </div>
      <div>
        3.打开“工具——MCT命令窗口”，打开刚才生成好的温度梯度mct文件，点击左下角“运行”按钮，完成后即可以查看到温度梯度荷载按截面顶面横坡倾斜了。
      </div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 213px; height: 57px" :src="url37" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">其他参数——风荷载参数</div>
    <div class="content-guide">
      <li>
        先选择地区，再点击“查询基本风速”，可以得到规范指定的U10和U100基本风速。
      </li>
      <li>
        地表分类——分A、B、C、D四类，分类依据见《公路桥梁抗风设计规范》（JTG/T
        3360-01-2018）表4.2.1。
      </li>
      <li>
        主梁基准高度——计算方法详见《公路桥梁抗风设计规范》（JTG/T
        3360-01-2018）第4.2.2、第4.2.3条。
      </li>
      <li>护栏高度——防撞护栏的高度，用于考虑防撞护栏受到的横向风荷载。</li>
      <li>
        通过勾选“考虑顺风向风荷载”和“考虑横风向风荷载”，在导出模型中生成对应的风荷载。
      </li>
      <li>
        计算过程——在成功导出mct文件后，点击该按钮可以查看到风荷载的详细计算过程。
      </li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 749px; height: 114px" :src="url38" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">其他参数—挂篮荷载</div>
    <div class="content-guide">
      <div>可以在指定挂篮自重和根据最大节段重量比例2种方式内选择</div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 323px; height: 57px" :src="url39" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">其他参数——施工阶段时间</div>
    <div class="content-guide">
      <div>通过定义各部位施工时间，让收缩徐变计算结果更符合实际情况。</div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 418px; height: 57px" :src="url40" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">其他参数——抗震计算参数</div>
    <div class="content-guide">
      <div>
        进行抗震计算时，地基弹簧的约束刚度通常需要放大2～2.5倍，这里可以填写放大倍数，不需要再修改地质参数。
      </div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 194px; height: 57px" :src="url41" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">导出设置——汽车荷载放大系数</div>
    <div class="content-guide">
      <div>
        汽车荷载放大系数——采用单梁模型时，汽车荷载应力验算结果是采用截面横向平均值，
        与实际腹板位置应力集中情况不符，故这里提供一个放大系数让模型计算结果更符合实际情况。具体值由设计人员根据设计经验取定。
      </div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 168px; height: 40px" :src="url42" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <div style="height: 120px"></div>
</template>
<script>
export default {
  data() {
    return {
      url1: require("@/assets/png/unit6/1.png"),
      url2: require("@/assets/png/unit6/2.png"),
      url3: require("@/assets/png/unit6/3.png"),
      url4: require("@/assets/png/unit6/4.png"),
      url5: require("@/assets/png/unit6/5.png"),
      url6: require("@/assets/png/unit6/6.png"),
      url7: require("@/assets/png/unit6/7.png"),
      url8: require("@/assets/png/unit6/8.png"),
      url9: require("@/assets/png/unit6/9.png"),
      url10: require("@/assets/png/unit6/10.png"),
      url11: require("@/assets/png/unit6/11.png"),
      url11a: require("@/assets/png/unit6/11-1.png"),
      url12: require("@/assets/png/unit6/12.png"),
      url12a: require("@/assets/png/unit6/12-1.png"),
      url12b: require("@/assets/png/unit6/12-2.png"),
      url13: require("@/assets/png/unit6/13.png"),
      url13a: require("@/assets/png/unit6/13-1.png"),
      url14: require("@/assets/png/unit6/14.png"),
      url14a: require("@/assets/png/unit6/14-1.png"),
      url15: require("@/assets/png/unit6/15.png"),
      url15a: require("@/assets/png/unit6/15-1.png"),
      url16: require("@/assets/png/unit6/16.png"),
      url16a: require("@/assets/png/unit6/16-1.png"),
      url16b: require("@/assets/png/unit6/16-2.png"),
      url16c: require("@/assets/png/unit6/16-3.png"),
      url17: require("@/assets/png/unit6/17.png"),
      url17a: require("@/assets/png/unit6/17-1.png"),
      url17b: require("@/assets/png/unit6/17-2.png"),
      url17c: require("@/assets/png/unit6/17-3.png"),
      url17d: require("@/assets/png/unit6/17-4.png"),
      url18: require("@/assets/png/unit6/18.png"),
      url18a: require("@/assets/png/unit6/18-1.png"),
      url19: require("@/assets/png/unit6/19.png"),
      url20: require("@/assets/png/unit6/20.png"),
      url20a: require("@/assets/png/unit6/20-1.png"),
      url20b: require("@/assets/png/unit6/20-2.png"),
      url20c: require("@/assets/png/unit6/20-3.png"),
      url21: require("@/assets/png/unit6/21.png"),
      url21a: require("@/assets/png/unit6/21-1.png"),
      url22: require("@/assets/png/unit6/22.png"),
      url22a: require("@/assets/png/unit6/22-1.png"),
      url23: require("@/assets/png/unit6/23.png"),
      url23a: require("@/assets/png/unit6/23-1.png"),
      url23b: require("@/assets/png/unit6/23-2.png"),
      url23c: require("@/assets/png/unit6/23-3.png"),
      url23d: require("@/assets/png/unit6/23-4.png"),
      url24: require("@/assets/png/unit6/24.png"),
      url24a: require("@/assets/png/unit6/24-1.png"),
      url25: require("@/assets/png/unit6/25.png"),
      url25a: require("@/assets/png/unit6/25-1.png"),
      url26: require("@/assets/png/unit6/26.png"),
      url26a: require("@/assets/png/unit6/26-1.png"),
      url26b: require("@/assets/png/unit6/26-2.png"),
      url27: require("@/assets/png/unit6/27.png"),
      url27a: require("@/assets/png/unit6/27-1.png"),
      url28: require("@/assets/png/unit6/28.png"),
      url28a: require("@/assets/png/unit6/28-1.png"),
      url28b: require("@/assets/png/unit6/28-2.png"),
      url28c: require("@/assets/png/unit6/28-3.png"),
      url29: require("@/assets/png/unit6/29.png"),
      url29a: require("@/assets/png/unit6/29-1.png"),
      url30: require("@/assets/png/unit6/30.png"),
      url30a: require("@/assets/png/unit6/30-1.png"),
      url30b: require("@/assets/png/unit6/30-2.png"),
      url31: require("@/assets/png/unit6/31.png"),
      url31a: require("@/assets/png/unit6/31-1.png"),
      url32: require("@/assets/png/unit6/32.png"),
      url32a: require("@/assets/png/unit6/32-1.png"),
      url33: require("@/assets/png/unit6/33.png"),
      url33a: require("@/assets/png/unit6/33-1.png"),
      url34: require("@/assets/png/unit6/34.png"),
      url35: require("@/assets/png/unit6/35.png"),
      url36: require("@/assets/png/unit6/36.png"),
      url37: require("@/assets/png/unit6/37.png"),
      url38: require("@/assets/png/unit6/38.png"),
      url39: require("@/assets/png/unit6/39.png"),
      url40: require("@/assets/png/unit6/40.png"),
      url41: require("@/assets/png/unit6/41.png"),
      url42: require("@/assets/png/unit6/42.png"),
      fit: "fill",
      srcList2: [
        require("@/assets/png/unit6/2.png"),
        require("@/assets/png/unit6/2-1.png"),
      ],
      srcList3: [
        require("@/assets/png/unit6/3.png"),
        require("@/assets/png/unit6/3-1.png"),
        require("@/assets/png/unit6/3-2.png"),
        require("@/assets/png/unit6/3-3.png"),
        require("@/assets/png/unit6/3-4.png"),
        require("@/assets/png/unit6/3-5.png"),
        require("@/assets/png/unit6/3-6.png"),
        require("@/assets/png/unit6/3-7.png"),
        require("@/assets/png/unit6/3-8.png"),
        require("@/assets/png/unit6/3-9.png"),
      ],
      srcList5: [
        require("@/assets/png/unit6/5.png"),
        require("@/assets/png/unit6/5-1.png"),
      ],
    };
  },
};
</script>
